var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(Object.keys(_vm.reference).length > 0)?_c('vue-fabric',{ref:`label-${_vm.reference.id}`,staticClass:"canvas-thumbnail",attrs:{"id":`canvas-${_vm.reference.id}-${_vm.selectedTag._id}-${_vm.selectedTag.template}`,"data-ref":_vm.reference.id,"width":_vm.reference.screen_width,"height":_vm.reference.screen_height}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }